import client from '../../base-api';

const serviceURL = '/unemployed/socio-therapy-coaching';

const socioTherapyCoachingService = {
    getSocioTherapyCoachingList(unemployedId: number) {
        return client.get(`${serviceURL}/${unemployedId}`);
    },
    getSocioTherapyCoaching(id: number) {
        return client.get(`${serviceURL}/details/${id}`);
    },
    postSocioTherapyCoaching(coachingData: any) {
        return client.post(`${serviceURL}`, coachingData);
    },
    putSocioTherapyCoaching(coachingData: any, coachingId: number) {
        return client.put(`${serviceURL}/${coachingId}`, coachingData);
    },
    deleteSocioTherapyCoaching(coachingId: number) {
        return client.delete(`${serviceURL}/delete/${coachingId}`);
    },
}

export default socioTherapyCoachingService;